import React from 'react';

import Send from 'components/Messenger/Chat/Send';
import Messages from 'components/Messenger/Chat/Messages';
import Recipient from 'components/Messenger/Chat/Recipient';

import { useAppStore } from 'store/useAppStore';
import { useMessengerStore } from 'store/useMessengerStore';

const Chat = () => {
	// Use app's store
	const user = useAppStore(state => state.user);

	// Use messenger's store
	const conversation = useMessengerStore(state => state.conversations.find(c => c.id === state.active));

	return (
		<div className="flex flex-col h-full max-h-full">
			{/* Conversation's information */}
			<Recipient />

			{/* Conversation's messages */}
			<Messages userId={user.id} messages={conversation?.messages} />
			
			{/* Messaging controls */}
			<Send />
		</div>
	);
};

export default Chat;
